import { render } from "./TextLinkWithArrow.vue?vue&type=template&id=6a3dde29&scoped=true&ts=true"
import script from "./TextLinkWithArrow.vue?vue&type=script&lang=ts"
export * from "./TextLinkWithArrow.vue?vue&type=script&lang=ts"

import "./TextLinkWithArrow.vue?vue&type=style&index=0&id=6a3dde29&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3dde29"]])

export default __exports__